import { render, staticRenderFns } from "./GameList.vue?vue&type=template&id=61c89cf8&scoped=true"
import script from "./GameList.vue?vue&type=script&lang=ts"
export * from "./GameList.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./GameList.vue?vue&type=style&index=0&id=61c89cf8&prod&scoped=true&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "61c89cf8",
  "c2ca2e92"
  
)

export default component.exports